// src/utils/stateRouting.js
//
// Shared helpers for mapping between URL paths and the 2-letter state code
// used throughout the app. Extracted from App.js so other modules (e.g.
// SelectedStateContext) can determine whether the current URL already
// carries an explicit state selection without duplicating the state list.

export const VALID_STATES = new Set([
  'AL','AK','AZ','AR','CA','CO','CT','DE','DC','FL','GA','HI','ID','IL','IN',
  'IA','KS','KY','LA','ME','MD','MA','MI','MN','MS','MO','MT','NE','NV','NH',
  'NJ','NM','NY','NC','ND','OH','OK','OR','PA','RI','SC','SD','TN','TX','UT',
  'VT','VA','WA','WV','WI','WY',
]);

// Extracts the 2-letter state code from a pathname that contains a /:state
// segment, e.g. /oh, /value-finder/oh, /promotions/oh, /promo-finder/oh.
// Returns the uppercased code, or null if the URL carries no state segment.
export function getStateFromPath(pathname) {
  const patterns = [
    /^\/([a-z]{2})$/i,
    /^\/value-finder\/([a-z]{2})$/i,
    /^\/promotions\/([a-z]{2})$/i,
    /^\/promo-finder\/([a-z]{2})$/i,
  ];
  for (const pattern of patterns) {
    const match = pathname.match(pattern);
    if (match) return match[1].toUpperCase();
  }
  return null;
}

// Convenience check used to decide whether the current URL already contains
// an explicit, valid state selection (highest priority in the state
// resolution order).
export function urlHasExplicitState(pathname) {
  const code = getStateFromPath(pathname);
  return !!code && VALID_STATES.has(code);
}
